import { Injectable } from '@angular/core'
import { BaseRequestOptions, RequestOptionsArgs, RequestOptions } from '@angular/http'

import { TokenName } from '../../config'

@Injectable()

export class RequestOptionsExtension extends BaseRequestOptions {

  constructor() {
    super()
    this.headers.set('Content-Type', 'application/json')
  }

  merge(options?: RequestOptionsArgs): RequestOptions {
    const newOptions = super.merge(options)
    const item = JSON.parse(localStorage.getItem(TokenName))
    const token = item && item.token
    newOptions.headers.set('Authorization', `Bearer ${token}`)
    return newOptions
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/request-options.extension.ts